import { Logout } from '@mui/icons-material'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { useAuth } from '../../Context/AuthContext';

const LogoutDialog = ({ logoutConfirmOpen, setLogoutConfirmOpen }: { logoutConfirmOpen: boolean; setLogoutConfirmOpen: (open: boolean) => void }) => {
    const { handleLogout } = useAuth();
    return (
        <Dialog
            open={logoutConfirmOpen}
            onClose={() => setLogoutConfirmOpen(false)}
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    maxWidth: 400,
                },
            }}
        >
            <DialogTitle sx={{ pb: 1 }}>
                <Box display="flex" alignItems="center" gap={1}>
                    <Logout sx={{ color: "#ef4444" }} />
                    <Typography variant="h6" fontWeight={600}>
                        Confirm Logout
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Typography color="#6b7280">
                    Are you sure you want to logout? You will need to login again to access your account.
                </Typography>
            </DialogContent>
            <DialogActions sx={{ p: 2, pt: 0, gap: 1 }}>
                <Button
                    onClick={() => setLogoutConfirmOpen(false)}
                    variant="outlined"
                    sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        borderColor: "#e5e7eb",
                        color: "#6b7280",
                        "&:hover": {
                            borderColor: "#d1d5db",
                            backgroundColor: "#f9fafb",
                        },
                    }}
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleLogout}
                    variant="contained"
                    sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        backgroundColor: "#ef4444",
                        "&:hover": {
                            backgroundColor: "#dc2626",
                        },
                    }}
                >
                    Logout
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default LogoutDialog